<template>
  <Col>
    <Row style="height: 6px; width: 24px;">
      <Icon type="ios-minus-empty" :size="25"></Icon>
    </Row>
    <Row style="height: 6px; padding-left: 5px; width: 24px;">
      <Icon type="ios-minus-empty" :size="25"></Icon>
    </Row>
    <Row style="height: 6px; padding-left: 5px; width: 24px;">
      <Icon type="ios-minus-empty" :size="25"></Icon>
    </Row>
  </Col>
</template>
<script>
export default {

};
</script>
<style lang="css" scoped>
.ivu-icon {
  color: #39f;
}
</style>


// WEBPACK FOOTER //
// src/components/NestedIcon.vue